<template>

  <v-form
    v-model="formdata.valid"
    ref="validatesubform"
    lazy-validation
  >
    <v-layout
      row
      wrap
    >

      <v-flex
        lg6
        sm6
      >
        <v-text-field
          label="Task Name"
          prepend-icon="tune"
          v-model="formdata.title"
          required
          :rules="formdata.requiredfield"
        ></v-text-field>
      </v-flex>

      <v-flex
        sm6
        lg6
      >
        <v-autocomplete
          flat
          :items="folderStatus"
          v-model="formdata.statusCodeID"
          label="Status"
          chips
          prepend-icon="beenhere"
          required
          :rules="formdata.requiredfield"
          item-text="status"
          item-value="statusCodeID"
        >
          <template
            slot="selection"
            slot-scope="data"
          >
            <v-chip
              :selected="data.selected"
              close
              class="chip--select-multi"
              @input="removeStatus(data.item)"
            >
              <v-avatar
                class="primary white--text"
                v-text="data.item.status.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item.status }}
            </v-chip>
          </template>
          <template
            slot="item"
            slot-scope="data"
          >
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <!-- <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar> -->
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.status"></v-list-tile-title>
                <!-- <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title> -->
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
      </v-flex>
      <!-- <v-flex
        lg12
        sm12
      >
         
        <p> Main folder Description</p>
        <quill-editor
          class="quill"
          :content="maindescription"
          :options="editorOption"
          v-model="maindescription"
          aria-placeholder="Main folder Content here..."
        >
        </quill-editor>
        </br></br></br></br>
      </v-flex> -->
      <v-flex
        lg12
        sm12
      >
        <!-- <v-textarea
            prepend-icon="note_add"
            v-model="formdata.description"
            label="Description"
          >
          </v-textarea> -->
        <p> Task Description</p>
        <quill-editor
          class="quill"
          :content="formdata.description"
          :options="editorOption"
          v-model="formdata.description"
          aria-placeholder="Main folder Content here..."
        >
        </quill-editor>
        </br></br></br></br>
      </v-flex>
      <v-flex
        sm6
        lg6
      >
        <upload-btn
          ref="refsubfolder"
          :fileChangedCallback="filesubChanged"
          title="Upload your file"
          name="uploadsubfolder"
          uniqueId
        >
          <template slot="icon-left">
            <v-icon
              left
              color="white"
            >attachment</v-icon>
          </template>
        </upload-btn>
        <div class="large-12 medium-12 small-12 cell">
          <div
            v-for="(file, key) in uploadedFiles"
            class="file-listing"
          >{{ file.name }}
            <v-btn
              icon
              v-if="!showdownloads"
              @click="removeFile( key )"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn
              icon
              v-if="showdownloads"
              @click="downloadFile( key )"
            >
              <v-icon>save_alt</v-icon>
            </v-btn>
          </div>
        </div>
      </v-flex>

    </v-layout>

  </v-form>

</template>

<script>
import UploadButton from 'vuetify-upload-button';
import Bytes from 'bytes';
import { uploadDocuments, downloadFile, documentUsers } from '@/api/document';
import { getSubFoldersId, getSubFolders, getFolderTreeId, createFolders, updateFolders, createSubFolder, updateSubFolder, deleteFolders, getFolderFiles, getFolder, getFolderTypes, getFolders } from '@/api/folder';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import GlobalMessage from '@/constant'

export default {
  components: {
    'upload-btn': UploadButton,

    quillEditor,

  },

  data: () => ({
    scrollSettings: {
      maxScrollbarLength: 160
    },
    personalTags: [
      'Programming',
      'Design',
      'Vue',
      'Vuetify'
    ],
    search: null,
    folderStatus: [
      { status: 'Draft', statusCodeID: 511 },
      { status: 'Assigned', statusCodeID: 512 },
      { status: 'Cancelled', statusCodeID: 514 }],


    //personalTags: [{ tagId: 1, tag: 'Demo' }],

    editorOption: {

    },
    // maindescription: '',
    mainFolderID: null,
    parentFolderID: null,

    menudue: false,
    loader: false,
    size: 'lg',
    view: 'grid',
    folder: false,
    folderfiles: new FormData(),
    showdownloads: false,
    parentTaskID: null,
    mainTaskId: null,
    formdata: {
      valid: false,
      folderID: -1,
      mainFolderID: null,
      parentFolderID: null,
      date: new Date(),
      title: '',
      name: '',
      folderTypeID: null,
      // assignedTo: [],
      // dueDate: new Date(),
      description: '',
      // assignedCC: [],
      // sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      // tagMasterID: -1,
      // tagIds: [],
      // personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      // isSpecialFile: true,
      // isTemp: true,
      uploadedFile: null,
      // onBehalfName: '',
      // overDueAllowed: 'false',
      // followUp: 'false',
    },
    defaultData: {
      valid: false,
      folderID: -1,
      date: new Date(),
      mainFolderID: null,
      parentFolderID: null,
      name: '',
      folderTypeID: null,
      title: '',
      // assignedTo: [],
      // dueDate: new Date(),
      description: '',
      // projectID: null,
      // assignedCC: [],
      // onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      // tagMasterID: -1,
      // tagIds: [],
      // personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      // isSpecialFile: true,
      // isTemp: true,
      // description: '',
      uploadedFile: null,
      // onBehalfName: '',
      // overDueAllowed: 'false',
      // followUp: 'false',
      // mainTaskId: null,
    },

    // tagItems: [],
    // projectItems: [],
    userItems: [],
    userGroupItems: [],
    items: [],
    folderItems: [],
    folderItemLink: [],
    allFiles: [],
    uploadedFiles: [],
    editFile: {
      name: '',
      size: '',
      contentType: '',
    },
    height: {
      type: String,
      default: null,
    },
  }),
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    }
  },
  watch: {
    model (val) {
      if (val.length > 5) {
        this.$nextTick(() => this.model.pop())
      }
    }
  },

  mounted () {

  },
  created () {
    window.getApp.$on('INITIALIZE_SUBFOLDER', () => {
      this.initialize();
    });
    window.getApp.$on('EDIT_SUBFOLDER', item => {
      this.initialize();
      this.formdata = item
      this.showdownloads = true;
      this.uploadedFiles = [],
        this.parentFolderID = item.parentFolderID;
      this.mainFolderID = item.mainFolderID;
      this.formdata.addedDate = this.formateDate(item.addedDate);
    });
    window.getApp.$on('ADD_SUBFOLDER', item => {
      // console.log(item);
      //alert(item.mainTaskId);
      this.initialize();
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.formdata.addedDate = this.formateDate(item.addedDate);
      this.parentFolderID = item.folderID;
      this.mainFolderID = item.mainFolderID;
      this.name = item.name;
    });
    window.getApp.$on('SAVE_SUBFOLDER', folderID => {
      this.parentFolderID = folderID;
      this.savesub();
    });
    window.getApp.$on('SEND_FOLDEROBJ', objFolder => {
      this.description = objFolder.description;
      this.parentFolderID = objFolder.parentFolderID;
      this.description = objFolder.description;
      this.name = objFolder.name;
      this.mainFolderID = objFolder.mainFolderID;
      //  for (var prop in objTask.assignedCC) {
      //       this.formdata.assignedCC.push(objTask.assignedCC[prop]);
      //     }      
    });
  },

  methods: {
    formateDate (string) {
      return string ? new Date(string).toISOString().substr(0, 10) : '';
    },
    // removeTag (item) {

    //   const index = this.formdata.tagIds.indexOf(item.tagMasterID)
    //   if (index >= 0) this.formdata.tagIds.splice(index, 1)
    // },
    // removeCC (item) {
    //   const index = this.formdata.assignedCC.indexOf(item.userID)
    //   if (index >= 0) this.formdata.assignedCC.splice(index, 1)
    // },
    removeStatus (item) {
      this.formdata.statusCodeID = null;
    },
    // removeProject (item) {
    //   //const index = this.projectItems.indexOf(item)
    //   this.formdata.projectID = null;
    // },
    // removePTag (item) {
    //   const index = this.formdata.personaltagIds.indexOf(item)
    //   if (index >= 0) this.formdata.personaltagIds.splice(index, 1)
    // },
    initialize () {
      // this.formdata.assignedCC = [];
      this.formdata = Object.assign({}, this.defaultData);
      this.formdata.addedByUser = this.$store.state.auth.userName;
      this.loader = true;
      this.formdata.addedDate = new Date().toISOString().substr(0, 10);
      // this.formdata.assignedCC = this.assignedCC;
      // this.formdata.onBehalfID = this.onBehalfID;
      getApplicationUsers('')
        .then(response1 => {
          this.userItems = response1.data;
          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getUserGroups('')
        .then(response2 => {
          this.userGroupItems = response2.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // getProjects('')
      //   .then(response2 => {
      //     this.projectItems = response2.data;
      //     this.loader = false;

      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });

      getFolders('')
        .then(response3 => {
          this.gridItems = response3.data;
          this.parentFolderDropItems = response3.data;
          this.mainFolderDropItems = response3.data;
          //this.folderTypeDropItems = response.data;
          this.loader = false;
          console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getFolderTypes('')
        .then(response4 => {
          //this.gridItems = response1.data;
          this.folderTypeDropItems = response4.data;
          this.loader = false;
          //console.log(this.gridItems);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      // getTagMaster('')
      //   .then(response => {
      //     this.tagItems = response.data;
      //     this.loader = false;
      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);

      //   });
      // getPersonalTags(-1, this.$store.state.auth.userId)
      //   .then(response => {
      //     this.PersonaltagItems = response.data;
      //     this.loader = false;
      //   })
      //   .catch(error => {
      //     this.loader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);

      //   });

    },
    // getAttachments () {
    //   getTaskAttachment(this.formdata.folderID)
    //     .then(response => {

    //       this.editFile.name = response.data[0].fileName;
    //       this.editFile.contentType = response.data[0].contentType;
    //       this.editFile.size = response.data[0].fileSize;
    //       this.showdownloads = true;

    //       this.uploadedFiles.push(this.editFile);
    //       this.loader = false;

    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });
    // },
    filesubChanged (file) {
      console.log(file);
      this.uploadedFiles.push(file);
      this.showdownloads = false;
      this.loader = true;
      this.folderfiles.append("file", file, file.name);
      uploadDocuments(this.folderfiles)
        .then(response => {
          this.formdata.sessionID = response.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    removeFile (key) {
      this.uploadedFiles.splice(key, 1);
    },
    // isImage (file) {
    //   return this.imageMime.includes(file.fileType);
    // },
    // mimeIcons (file) {
    //   return this.imageMime.includes(file.fileType)
    //     ? 'image'
    //     : 'insert_drive_file';
    // },
    // showDetail (file) {
    //   this.editedIndex = this.documents.indexOf(file);
    //   this.editedItem = Object.assign({}, file);

    //   documentUsers(this.editedItem.documentID)
    //     .then(response => {
    //       this.editedItem.userID = response.data;
    //       this.loader = false;
    //     })
    //     .catch(error => {
    //       this.loader = false;
    //       window.getApp.$emit('APP_API_ERROR', error);
    //     });

    //   this.uploadFile = true;
    // },
    // showFiles (item) {
    //   console.log(item);
    //   this.documents = this.allFiles.filter(f => f.departmentID == item.value);
    //   this.view = 'list';
    // },
    downloadFile (key) {

      this.loader = true;
      downloadFile(this.formdata.attachments[key])
        .then(response => {
          let blob = new Blob([response.data], { type: this.editFile.contentType })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.editFile.name
          link.click()
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },

    savesub () {
      if (this.$refs.validatesubform.validate()) {
        this.loader = true;
        if (this.formdata.folderID > -1) {
          this.formdata.modifiedByUserId = this.$store.state.auth.userId;
          this.formdata.modifiedDate = new Date();
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date();
          this.formdata.mainFolderID = this.mainFolderID;
          this.formdata.parentFolderID = this.parentFolderID;
          updateSubFolder(this.formdata)
            .then(response => {
              this.loader = false;
              this.actionButton = true;
              window.getApp.$emit('INITIALIZE_SUBFOLDER', this.mainFolderID);
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          //this.formdata.folderID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.formdata.addedByUserId = this.$store.state.auth.userId;
          this.formdata.addedDate = new Date();
          this.formdata.statusCodeID = 1;
          this.formdata.parentFolderID = this.parentFolderID;
          this.formdata.mainFolderID = this.mainFolderID;
          createSubFolder(this.formdata)
            .then(response => {
              this.loader = false;
              this.formdata = response.data;
              console.log(this.mainFolderID);
              window.getApp.$emit('INITIALIZE_SUBFOLDER', this.mainFolderID);
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
      }
      else {
        window.getApp.$emit('APP_API_VAL', GlobalMessage.VALIDATE);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.quill {
  height: 250px;
}
</style>


// WEBPACK FOOTER //
// src/pages/document/subfolder.vue